import React from "react";
import { useNavigate } from "react-router-dom";

interface ListsProps {
  isOpen: boolean;
  source: string;
  placeholder: String;
  redirect: String;
}

const Lists: React.FC<ListsProps> = ({
  isOpen,
  source,
  placeholder,
  redirect,
}) => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate(String(redirect));
  };

  return (
    <div className={`cursor-pointer flex flex-col gap-0 w-[100%] relative`}>
      <div className={`px-4`}>
        <button
          onClick={handleRedirect}
          className={`px-4 py-2 ${ 
            isOpen
              ? window.location.pathname === redirect ? "bg-[#3F81FE] hover:bg-[#3F81FE]" : "hover:bg-[#dce6f9]  flex items-center justify-between gap-2"
              : window.location.pathname === redirect ? "bg-[#3F81FE]  hover:bg-[#3F81FE]" : " "
          } outline-0 w-full rounded-md text-[#323232]`}
        >
          <div className="flex items-center gap-2 font-normal text-sm">
            {/* <img
              src={window.location.pathname === redirect ? `${source}-active.svg` : `${source}.svg`}
              alt=""
              className="w-6 h-6"
            /> */}
            <span className={`${isOpen ? "" : "hidden"}  ${window.location.pathname === redirect ? "text-white" : ""}`}>
              {placeholder}
            </span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Lists;
